/**
 * mwApp.partnerPrograms module <br>
 * Work with partnerPrograms: show/add/edit/remove
 *
 * @namespace mwApp/partnerPrograms
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/partnerPrograms
 * @see mwApp/partnerPrograms
 *
 * @ngdoc config
 * @name mwApp/partnerPrograms.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /partner-programs
     */
    .state('app.partnerPrograms', {
      abstract: true,
      url: '/partner-programs',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/partnerPrograms.controller:PartnerProgramsCtrl}
     * @name /partnerPrograms
     * @memberof mwApp/partnerPrograms.config:ConfigRoutes
     */
    .state('app.partnerPrograms.list', {
      url: '',
      templateUrl: 'components/partnerPrograms/views/partnerPrograms.html',
      controller: 'PartnerProgramsCtrl as vm',
      label: 'Partner Programs',
      access: '',
      resolve: {
        enabled: /* @ngInject */ function ($state, authSvc) {
          if (!authSvc.hasEnabledFlag('FEATURE_PARTNERS_ENABLED')) {
            $state.go('app.404')
          }
        },
        extra: /* @ngInject */ function (PartnerProgram) {
          return PartnerProgram.loadExtra()
        }
      }
    })
}
